
angular.module('mtic.components.navbar')
.directive('navBarUser', function (userAccount, EventManager, $q, language, $timeout, $rootScope, LocaleService, $log, GenericPopup, api) {
  return {
    templateUrl: 'template.html',
    restrict: 'E',
    scope: {},
    link: function (scope, element, attrs) {
      var eventManager = new EventManager('navbar:user');
      var active_slug;
      var isUpdating=false;
      scope.language = language;
      scope.logout = function(){
        if(!navigator.onLine){
          $timeout(function(){
            scope.offline_post_submission = true;
          }, 200)
          return;
        }
        if(isUpdating){
          return;
        }

        isUpdating = true;
        eventManager.broadcast('logout:manual');
        if(active_slug && active_slug.indexOf('_m56_') > -1 &&!userAccount.getData().role.isTeacher){
          var defer = $q.defer();
          eventManager.broadcast("module:updateAndClose:resource",defer);
          defer.promise.then(function(){
            userAccount.logout();
            isUpdating = false;
          },function(){
            isUpdating = false;
          });
        }else{
          $timeout(function(){
            userAccount.logout();
            isUpdating = false;
          }, 300);
        }
      }

      scope.fullName = function(){
        return userAccount.getData().fullName
      }

      scope.isTeacher = function(){
        return userAccount.getData().role.isTeacher;
      }

      scope.numOfNotifications = function(){
        return 0;
      } 

      scope.isOcmtTeacher = function(){
        return scope.isTeacher() && $rootScope.isOCMT && !LocaleService.getIfIamUser();
      }

      scope.changePassowrd = function(password){
        scope.processingPasswordChange = true;
        api.postTeacherPasswordUpdate(password)
          .then(function(response){
            scope.processingPasswordChange = false;
            scope.showChangePasswordModal = false;
            GenericPopup.open('Reset Password', 'Password has been changed.');
          }).catch(function(err){
          scope.processingPasswordChange = false;
          scope.showChangePasswordModal = false;
          GenericPopup.open('Reset Password', 'There was an error updating the password.');
        })
      }

      eventManager.listen('module:open:resource', function(e, data){
        active_slug = data.slug;
      });

      eventManager.listen('module:close:resource', function(e, data){
        active_slug = "";
      });

    }
  }
})
